import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { AuthService } from 'src/app/auth-module/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-welcome-login',
  templateUrl: './welcome-login.component.html',
  styleUrls: ['./welcome-login.component.scss']
})
export class WelcomeLoginComponent implements OnInit {
  profileRegisteredDate = '';
  profileCompletion: Number = 0;
  profileStatus = '';
  total_hospt_reg: any;

  @ViewChild('carousel', { static: true }) carousel!: ElementRef;

  registrationCard: any = [
    {
      title: 'Registration',
      registeredDate: sessionStorage.getItem("created_at"),
      // description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
      percentage: 100,
      status: 'Completed'
    }
  ];

  qualityImprovement: any = [
    {
      title: 'Quality Improvement',
      registeredDate: 'Mar 23, 2023 12:45 pm',
      description: `Begin your QI Journey Here`,
      percentage: 100,
      status: 'QA Ready'
    }
  ];

  qualityAssessment: any = [
    {
      title: 'Quality Assessment',
      registeredDate: 'April 23, 2023 12:45 pm',
      description: `Begin your QA Journey Here`,
      percentage: 10,
      status: 'Assessment in progress'
    }
  ];

  carouselHeader: any = [
    {
      id: 1,
      imgPath: '../../../assets/images/workspace_premium_black_24dp(1).svg',
      text: `Total Hospital Registered In Manyata`,
      count: "",
    },
    // {
    //   id: 2,
    //   imgPath: '../../../assets/images/Group 16739.svg',
    //   text: `Hospitals Onboarded`,
    //   count: ""
    // },
    // {
    //   id: 3,
    //   imgPath: '../../../assets/images/Group 16740.svg',
    //   text: `Hospitals have completed QI Journey`,
    //   count: ""
    // }
  ];
  facility_name: string;
  userProfileStatus: string;
  is_profile_updated: any;

  constructor(private router: Router, private service: AuthService) {
    this.facility_name = sessionStorage.getItem("facility name")
    console.log(sessionStorage.getItem("facility name"));

    let token = sessionStorage.getItem("token");
    let userId = sessionStorage.getItem("userId");

    this.service.profileCompletion(userId, token).subscribe((response: any) => {
      this.profileCompletion = response.data.profile_percentage;
      if (this.profileCompletion == 100) {
        this.profileStatus = 'Completed';
      } else {
        this.profileStatus = 'Inprogress';
      }
    },
      (error) => {
        Swal.fire('Error', `${error.error.message}`, 'error')
      })

    this.service.getUserDetail(userId, token).subscribe((response: any) => {
      console.log('response in welcome', response.data);
      this.userProfileStatus = response?.data?.is_profile_updated && response?.data.is_payment ? 'Onboarded' : response?.data?.is_profile_updated && response?.data.is_payment == false ? 'Payment Pending' : response?.data?.is_profile_updated == false ? 'Registration Pending' : '';
      this.is_profile_updated = response?.data?.is_profile_updated;
      if (response?.data?.is_profile_updated) {
        sessionStorage.setItem('is_profile_updated', response?.data?.is_profile_updated);
      }
      this.total_hospt_reg = response?.data?.total_hosp_reg;
      this.carouselHeader[0].count = this.total_hospt_reg;
    })
  }

  ngOnInit(): void {
    this.profileRegisteredDate = moment(sessionStorage.getItem("created_at")).format("MMM DD YYYY  hh:mm a");
    console.log("created_at", sessionStorage.getItem("created_at"));
    console.log('created_at moment', moment(sessionStorage.getItem("created_at")).format("MMM DD YYYY LT"));




    fromEvent(this.carousel.nativeElement, 'slide.bs.carousel').subscribe((data: any) => {
      console.log(data);
      if (data.target.innerText.includes(this.carouselHeader[0].text)) {
        this.registrationCard = [
          {
            title: 'Registration',
            registeredDate: 'Dec 23, 2023 12:45 pm',
            description: `1Lorem ipsum other card ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 90,
            status: 'Assessment in progress'
          }
        ];
        this.qualityImprovement = [
          {
            title: 'Quality Improvement',
            registeredDate: 'Mar 3, 2023 12:45 pm',
            description: `Lorem ipsiusmod tam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 80,
            status: 'QA Ready'
          }
        ];

        this.qualityAssessment = [
          {
            title: 'Quality Assessment',
            registeredDate: 'April 3, 2023 12:45 pm',
            description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 30,
            status: 'Assessment in progress'
          }
        ];
      } else if (data.target.innerText.includes(this.carouselHeader[1].text)) {
        this.registrationCard = [
          {
            title: 'Registration',
            registeredDate: 'Jul 23, 2023 12:45 pm',
            description: `Lorem ipsum dolor sit amet, adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 100,
            status: 'Completed'
          }
        ];
        this.qualityImprovement = [
          {
            title: 'Quality Improvement',
            registeredDate: 'Mar 23, 2023 12:45 pm',
            description: `Lorem ipsiusmod tam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 100,
            status: 'QA Ready'
          }
        ];

        this.qualityAssessment = [
          {
            title: 'Quality Assessment',
            registeredDate: 'April 23, 2023 12:45 pm',
            description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 10,
            status: 'Assessment in progress'
          }
        ];
      } else {
        this.registrationCard = [
          {
            title: 'Registration',
            registeredDate: 'Feb 23, 2023 12:45 pm',
            description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 100,
            status: 'Completed'
          }
        ];

        this.qualityImprovement = [
          {
            title: 'Quality Improvement',
            registeredDate: 'Mar 23, 2023 12:45 pm',
            description: `Lorem ipsiusmod tam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 100,
            status: 'QA Ready'
          }
        ];

        this.qualityAssessment = [
          {
            title: 'Quality Assessment',
            registeredDate: 'April 23, 2023 12:45 pm',
            description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
            percentage: 10,
            status: 'Assessment in progress'
          }
        ];
      }

    });
  }

  goToProfile() {
  let encryptedParams = btoa(`isDisable=true&is_profile_updated=${this.is_profile_updated}`);
    this.router.navigateByUrl(`login/detailed-register?${encryptedParams}`)
  }

}
